<template>
  <div class="tem-switch"></div>
</template>

<script>
export default {};
</script>

<style>
.tem-switch {
  margin-top: 20px;
  width: 100%;
  height: 168px;
  background-image: url("../../../../../../../assets/property/tem-switch.png");
  background-size: cover;
}
</style>
